import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/empty-list.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "card-head rounded-t-lg md:h-25vh flex flex-col-reverse" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-30px text-white font-semibold text-center md:mb-30" }, "Pusat Bantuan Kru & Pelanggan", -1)
const _hoisted_4 = { class: "md:flex items-center gap-3" }
const _hoisted_5 = { class: "w-full mb-2 md:w-1/2 lg:w-37% lg:mb-0" }
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "w-full mb-2 md:w-1/2 lg:w-1/4 lg:mb-0" }
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "w-full mb-2 md:w-1/2 lg:w-1/4 lg:mb-0" }
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "w-full md:w-150" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-search text-white text-sm" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-white font-bold text-sm" }, "Cari Data", -1)
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "container-no-data" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "wrap-no-data my-50" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Oops, belum ada data yang bisa kami tampilkan. Masukkan data pencarian terlebih dulu!")
  ])
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "w-full md:w-1/3" }
const _hoisted_20 = { class: "flex items-center gap-2" }
const _hoisted_21 = { class: "text-xl font-extrabold" }
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = { class: "mr-2 text-grey-5 text-xs" }
const _hoisted_24 = { class: "border-left-grey-4 pl-2 text-grey-5 text-xs" }
const _hoisted_25 = { class: "flex gap-6 w-full md:w-1/3" }
const _hoisted_26 = { class: "w-full md:w-1/2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-grey mb-2" }, "Kondektur", -1)
const _hoisted_28 = { class: "text-sm font-bold" }
const _hoisted_29 = { class: "w-full md:w-1/2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-grey mb-2" }, "Sopir", -1)
const _hoisted_31 = { class: "text-sm font-bold" }
const _hoisted_32 = { class: "flex items-center gap-3 w-full md:w-1/3 justify-between" }
const _hoisted_33 = { class: "text-primary text-2xl font-extrabold" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Lihat Detail"), -1)

import { getCurrentInstance, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import Card from 'primevue/card'
import Button from 'primevue/button'
import Paginator from '@/views/components/paginator/Paginator.vue'
import { DatePicker } from 'v-calendar'
import * as Yup from 'yup'
import { Form, Field } from 'vee-validate'
import InputIconRightNoBorder from '@/views/components/form/InputIconRightNoBorder.vue'
import moment from 'moment'
import rgxExp from '@/utils/helpers/regExp'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import { useRouter } from 'vue-router'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import apiUseCase from '@/usecase/apiUseCase'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const transactionPpEndpoint = '/transaction/v2/TransactionPps'

const app = getCurrentInstance()
const {
  $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const router = useRouter()
const store = useStore()
const dataSource = ref([] as any)

const filters = {
  search: '',
  filterField: [] as any,
  pageSize: 10,
  pageNumber: 1,
  custom: [] as any,
  totalRecords: 0
}

const formValues = reactive({
  regNumber: '',
  startDate: null as any,
  endDate: null as any
})

const schema = Yup.object().shape({
  regNumber: Yup.string()
    .matches(rgxExp.notPrefixSpace, 'Nopol Bus tidak boleh hanya menggunakan spasi')
    .required('Nopol Bus tidak boleh kosong')
    .max(15, 'Nopol Bus tidak boleh melebihi 15 karakter'),
  startDate: Yup.string().required('Tanggal Awal tidak boleh kosong'),
  endDate: Yup.string().required('Tanggal Akhir tidak boleh kosong'),
})

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpEndpoint}${returnUrlPrams(filters)}`).then((response) => {
    console.log('response', response)
    const {
      error,
      result,
      count
    } = response
    if (!error) {
      filters.totalRecords = count
      dataSource.value = result
    }
  })
  console.log('dataSource', dataSource.value)
  store.dispatch('hideLoading')
}

const submit = (values: any) => {
  console.log('submit', values)
  filters.custom = [
    ['q', '=', values.regNumber],
    ['startDate', '=', moment(values.startDate).format('YYYY-MM-DD')],
    ['endDate', '=', moment(values.endDate).format('YYYY-MM-DD')]
  ]
  getAllData()
}

const openDetail = (id: any) => {
  router.push({
    name: 'helpdesk-detail',
    params: {
      id
    }
  })
}

const onChangePage = (val: any) => {
  filters.pageNumber = val.page + 1
  getAllData()
  console.log('pagination', val)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card), { class: "card-no-shadow helpdesk" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _createVNode(_unref(Form), {
              onSubmit: submit,
              "initial-values": formValues,
              "validation-schema": _unref(schema),
              validateOnMount: false
            }, {
              default: _withCtx(({ errors, values, setFieldValue }) => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(Field), { name: "regNumber" }, {
                      default: _withCtx(({ field, handleChange, handleBlur }) => [
                        _createVNode(InputIconRightNoBorder, {
                          modelValue: values.regNumber,
                          "onUpdate:modelValue": ($event: any) => ((values.regNumber) = $event),
                          canClick: false,
                          "input-background": "#EBEFF4",
                          icon: _unref(icon).svg.kondekturGrey,
                          placeholder: "Masukkan Nopol Bus / Nama Kondektur "
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "icon"]),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(errors.regNumber), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(Field), { name: "startDate" }, {
                      default: _withCtx(({ field, handleChange, handleBlur }) => [
                        _createVNode(_unref(DatePicker), _mergeProps(field, {
                          modelValue: values.startDate,
                          "onUpdate:modelValue": [($event: any) => ((values.startDate) = $event), (val) => setFieldValue('startDate', val)],
                          masks: {
                        input: 'DD/MM/YYYY'
                      },
                          maxDate: values.endDate ? new Date(new Date(values.endDate).setDate(new Date(values.endDate).getDate() - 1)) : null
                        }), {
                          default: _withCtx(({ togglePopover }) => [
                            _createVNode(InputIconRightNoBorder, {
                              value: _unref(moment)(values?.startDate).format('DD MMMM YYYY'),
                              readonly: true,
                              canClick: true,
                              "input-background": "#EBEFF4",
                              icon: _unref(icon).svg.departureScheduleGrey,
                              placeholder: "Pilih tanggal awal",
                              onActInput: togglePopover
                            }, null, 8, ["value", "icon", "onActInput"])
                          ]),
                          _: 2
                        }, 1040, ["modelValue", "onUpdate:modelValue", "maxDate"]),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(errors.startDate), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_unref(Field), { name: "endDate" }, {
                      default: _withCtx(({ field, handleChange, handleBlur }) => [
                        _createVNode(_unref(DatePicker), _mergeProps(field, {
                          modelValue: values.endDate,
                          "onUpdate:modelValue": [($event: any) => ((values.endDate) = $event), (val) => setFieldValue('endDate', val)],
                          masks: {
                        input: 'DD/MM/YYYY'
                      },
                          minDate: new Date(new Date(values.startDate).setDate(new Date(values.startDate).getDate() + 1))
                        }), {
                          default: _withCtx(({ togglePopover }) => [
                            _createVNode(InputIconRightNoBorder, {
                              value: _unref(moment)(values?.endDate).format('DD MMMM YYYY'),
                              readonly: true,
                              canClick: values?.startDate,
                              "input-background": "#EBEFF4",
                              icon: _unref(icon).svg.departureScheduleGrey,
                              placeholder: "Pilih tanggal akhir",
                              onActInput: togglePopover
                            }, null, 8, ["value", "canClick", "icon", "onActInput"])
                          ]),
                          _: 2
                        }, 1040, ["modelValue", "onUpdate:modelValue", "minDate"]),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(errors.endDate), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_unref(Button), {
                      type: "submit",
                      class: "mb-2 sm:mb-0 flex gap-2 w-max"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12,
                        _hoisted_13
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }, 8, ["initial-values", "validation-schema"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (dataSource.value.length < 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataSource.value, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: data.id
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex gap-3 border-grey-3 p-10px mb-20px rounded-lg", data.isClosed ? 'background-grey-3' : ''])
                    }, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, _toDisplayString(data.VehicleRegNumber), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(data.MsStatusId === 45 ? 'chip-red-solid' : 'chip-green-solid')
                          }, _toDisplayString(data.MsStatusName), 3)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, _toDisplayString(`${data.TotalTicket ?? '-'} Penumpang`), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(moment)(data.RosterDate).format('DD MMMM YYYY - HH:mm')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, _toDisplayString(data.CondecturName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, _toDisplayString(data.DriverName), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(currencyNumberFormat)(data.TotalTicketAmount)), 1),
                        _createElementVNode("div", null, [
                          _createVNode(_unref(Button), {
                            class: "flex gap-2 extra-submit-button p-1",
                            outlined: true,
                            onClick: ($event: any) => (openDetail(data.Id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_34
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ], 2)
                  ]))
                }), 128)),
                (dataSource.value.length > 0)
                  ? (_openBlock(), _createBlock(Paginator, {
                      key: 0,
                      rows: filters.pageSize,
                      totalRecords: filters.totalRecords,
                      onOnPage: onChangePage
                    }, null, 8, ["rows", "totalRecords"]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})